import { styled } from '@mui/material/styles';
import { LightGrayLabel } from './LightGrayLabel';

export const SmallLightLabel = styled(LightGrayLabel)(({ theme }) => ({
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  [theme.breakpoints.down('sm')]: {
    fontSize: 13
  }
}));
